// NATIVE 
import React, { useEffect, useState } from 'react'

// INSTALLED 
import { useFormikContext } from 'formik';
import { useDispatch } from 'react-redux';
import Divider from '@mui/material/Divider';
import { Button, Card, CardActionArea, CardMedia, Grid } from '@mui/material';

// CUSTOM 
import { uploadImgStore } from '../../../store/uploaders';
import { UploadButtonField } from '../../formFields/uploadButtonField';
import { LinearProgressWithLabel } from '../../LinearProgressWithLabel';




export const LogosNombreComercial = (props:any) => {


  const dispatch = useDispatch();

  const [percentage_upload_logo, setPercentageUploadLogo] = useState(0);
  const [file_logo_comercial, setFileLogo] = useState(null);
  const [preview_logo, setPreviewLogo] = useState('');
  const [file_n_name, setLogoFileName] = useState('');


  const [percentage_upload_post, setPercentageUploadPost] = useState(0);
  const [file_logo_post, setFilePost] = useState(null);
  const [preview_post, setPreviewPost] = useState('');
  const [file_post_name, setPostFileName] = useState('');

      const { formField: {
        logo_bn_company,
        logo_bn_post_company
      }
    } = props;


  const formikProps:any = useFormikContext();


    
    // VERIFICA QUE SI ESTA DEFINIDO EN EL FORMIK LOS LOGOS LOS PONE 
    // PORQUE EL STEPER LO BORRA AL VOLVER 
    useEffect(() => {
      
        if (formikProps.values.logo_bn_company) {
            const objectURL = URL.createObjectURL(formikProps.values.logo_bn_company);
            setPreviewLogo(objectURL);
            setPercentageUploadLogo(100);
        }

        if (formikProps.values.logo_bn_post_company) {
            const objectURL = URL.createObjectURL(formikProps.values.logo_bn_post_company);
            setPreviewPost(objectURL);
            setPercentageUploadPost(100);
        }

    }, []);
    

    const uploadFileLogo = async({ target }:any) => {


            
      const { name } = target.files[0];

      setLogoFileName(name);
      setFileLogo(target.files[0]);

      const objectURL = URL.createObjectURL(target.files[0]);
      setPreviewLogo(objectURL);
  
      formikProps.setFieldValue('logo_bn_company', target.files[0]);
      const { ok, data } = await dispatch( uploadImgStore( 'image-company', target.files[0], setPercentageUploadLogo) );
    
      console.log(data)
      if (ok) {
         formikProps.setFieldValue('logo_company_name_saved_file', data.imgName);
      }


    }

    const uploadFileLogoPost = async({ target }:any) => {
   
      
      const { name } = target.files[0];
      setPostFileName(name);
      setFilePost(target.files[0]);

      const objectURL = URL.createObjectURL(target.files[0]);
      setPreviewPost(objectURL);

      formikProps.setFieldValue('logo_bn_post_company', target.files[0]);
      const { ok, data } = await dispatch( uploadImgStore( 'image-company', target.files[0], setPercentageUploadPost) );
    
      if (ok) {
         formikProps.setFieldValue('logo_post_company_name_saved_file', data.imgName);
      }
  
      
    }

  return (
    <div>
        <Grid container spacing={2}>
            <Grid size={{ xs: 6 }}>
                <Button>  Sube Tu Logo Comercial</Button>
                <Divider/>
                <UploadButtonField onChange={uploadFileLogo} 
                                   accept={'image/*'} 
                                   name={logo_bn_company.name} 
                                   label={logo_bn_company.label} 
                                   text={'Subir Archivo'} />
                
                {
                  formikProps.values.logo_bn_company
                       ?
                       <>
                        <Card sx={{ maxWidth: 345, marginTop: 7 }}>
                        <CardActionArea>
                          <CardMedia
                            component="img"
                            height="140"
                            sx={{ objectFit: 'contain' }}
                            image={preview_logo}
                            alt="Logo Nombre Comercial"
                          />
                        </CardActionArea>
                      </Card>
                        <Card variant="elevation" sx={{  marginTop: 1.5, padding: 1, height: '70%',  }}>
                         <LinearProgressWithLabel percentage={percentage_upload_logo} label={formikProps.values.logo_bn_company.name} hasIcon={false} />
                        </Card>
                       </>
                       :
                       ''
                }
            </Grid>
            <Grid size={{ xs: 6 }}>
                <Button>  Sube Tu Logo Post Comercial</Button>
                <Divider/>
                <UploadButtonField onChange={uploadFileLogoPost} 
                                   accept={'image/*'} 
                                   name={logo_bn_post_company.name} 
                                   label={logo_bn_post_company.label} 
                                   text={'Subir Archivo'} />
                
                {
                  formikProps.values.logo_bn_post_company
                       ?
                        <>
                          <Card sx={{ maxWidth: 345, marginTop: 7 }}>
                            <CardActionArea>
                              <CardMedia
                                component="img"
                                height="140"
                                sx={{ objectFit: 'contain' }}
                                image={preview_post}
                                alt="Logo Nombre Comercial"
                              />
                            </CardActionArea>
                          </Card>
                          <Card variant="elevation" sx={{  marginTop: 1.5, padding: 1, height: '70%',  }}>
                           <LinearProgressWithLabel percentage={percentage_upload_post} label={formikProps.values.logo_bn_post_company.name} hasIcon={false} />
                          </Card>
                        </>
                       :
                       ''
                }
            </Grid>
        </Grid>
    </div> 
  )
}
